<template>
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <ul class="content">
                <el-select
                    style="margin-right: 20px"
                    v-for="(column, index) in dataList.optionsColumList"
                    v-model="valueObj[`${index + 1}`]"
                    value-key="value"
                    @change="changePreSelect($event, index + 1)"
                    class="m-2"
                    placeholder="请选择"
                    size="large"
                >
                    <el-option v-for="item in selectList[index + 1 + '']" :key="item.value" :label="item.label" :value="item" />
                </el-select>
            </ul>
            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                    <!-- 添加左侧操作按钮 -->
                    <template #operation>
                        <div class="bottom-operation">
                            <div class="button1" @click="openBatchDialog"><svg-icon name="batchEdit" class="icon" />编辑选项</div>
                        </div>
                    </template>
                </action-bar>
            </div>
            <cascade-dialog ref="CascadeEdit" :optionsList="dataList.optionsList" :columnsNumber="columnsNumber" @confirmOption="confirmOption" />
        </div>
    </div>
</template>
<script setup name="kr-cascade">
// js
import { ref, watch } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import CascadeDialog from "@/components/dialog/CascadeDialog.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
    // 编辑选项弹框默认几列选项
    columnsNumber: {
        type: Number,
        default: 4,
    },
});
// 复制题目，删除题目, 数据改变, 单题预览, 标题修改后
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);

const CascadeEdit = ref(null);
const titileInput = ref(null); // 为了标题聚焦使用
let selectList = ref({});
let valueObj = ref({}); // 虚拟绑定值

selectList.value["1"] = JSON.parse(JSON.stringify(props.dataList.optionsList));

watch(
    () => props.dataList,
    (curr, old) => {
        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);

defineExpose({ titileInput });

// 展示当前下拉框
function changePreSelect(e, index) {
    selectList.value[index + 1 + ""] = JSON.parse(JSON.stringify(e.children));
}
// 打开批量编辑选项弹框
function openBatchDialog() {
    CascadeEdit.value.dialogVisible = true;
}
function confirmOption(res) {
    props.dataList.optionsList = res.data;
    selectList.value["1"] = res.data && res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : [];
    // 列数
    props.dataList.optionsColumList = res.columns;
}
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

:deep(.el-select--large) {
    height: 34px;
}
.question-item {
    .content {
        display: flex;
    }
    .footer-operation {
        .bottom-operation {
            display: flex;
            justify-content: space-between;
            color: rgba(34, 64, 195, 1);
            font-size: 13px;
            .button1 {
                cursor: pointer;
                &:nth-child(2) {
                    margin: 0 30px;
                }
                .icon {
                    margin-right: 7px;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
